module.exports = __webpack_public_path__ + "assets/img/logistics-inform.1e38d939.png";